import { render, staticRenderFns } from "./BlockInfo.vue?vue&type=template&id=c0177fb0&scoped=true"
import script from "./BlockInfo.vue?vue&type=script&lang=js"
export * from "./BlockInfo.vue?vue&type=script&lang=js"
import style0 from "./BlockInfo.vue?vue&type=style&index=0&id=c0177fb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0177fb0",
  null
  
)

export default component.exports